import { Recharge } from "../../views/amount/recharge";
import { Withdrawal } from "../../views/amount/withdrawal";
import { BalanceLog } from "../../views/amount/balanceLog";
import { UserAddress } from "../../views/amount/userAddress";
import { UserTransfer } from "../../views/amount/UserTransfer";
import { InternationalRemittanceList } from "../../views/amount/InternationalRemittanceList";

import { langPage } from "../../locales";
import { InternationalRemittanceCountriesList } from "../../views/amount/InternationalRemittanceCountriesList";
import { InternationalRemittanceChannelList } from "../../views/amount/InternationalRemittanceChannelList";
import { InternationalRemittanceCreditedTimesList } from "../../views/amount/InternationalRemittanceCreditedTimesList";
import { InternationalRemittanceLimitList } from "../../views/amount/InternationalRemittanceLimitList";
import { InternationalRemittanceSlippageList } from "../../views/amount/InternationalRemittanceSlippageList";
import { InternationalRemittanceCurrencyConversionList } from "../../views/amount/InternationalRemittanceCurrencyConversionList";


const lang = langPage?.amount;

export const amountRouters = [
    {
        path: "/amount/userAddress",
        name: "userAddress",
        exact: true,
        component: UserAddress,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.userAddress?.name,
                    path: ""
                }
            ],
            privilegeCode: "userAddress",
        }
    },
    {
        path: "/amount/recharge",
        name: "recharge",
        exact: true,
        component: Recharge,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.recharge?.name,
                    path: ""
                }
            ],
            privilegeCode: "recharge",
        }
    },
    {
        path: "/amount/withdrawal",
        name: "withdrawal",
        exact: true,
        component: Withdrawal,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.withdrawal?.name,
                    path: ""
                }
            ],
            privilegeCode: "withdrawal",
        }
    },
    {
        path: "/amount/balanceLog",
        name: "balanceLog",
        exact: true,
        component: BalanceLog,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: lang?.balanceLog?.name,
                    path: ""
                }
            ],
            privilegeCode: "balanceLog",
        }
    },
    {
        path: "/amount/userTransfer",
        name: "userTransfer",
        exact: true,
        component: UserTransfer,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "用户转账列表",
                    path: ""
                }
            ],
            privilegeCode: "userTransfer",
        }
    },
    {
        path: "/amount/internationalRemittanceList",
        name: "internationalRemittanceList",
        exact: true,
        component: InternationalRemittanceList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceList",
        }
    },
    {
        path: "/amount/internationalRemittanceCountriesList",
        name: "internationalRemittanceCountriesList",
        exact: true,
        component: InternationalRemittanceCountriesList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款国家列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceCountriesList",
        }
    },
    {
        path: "/amount/internationalRemittanceChannelList",
        name: "internationalRemittanceChannelList",
        exact: true,
        component: InternationalRemittanceChannelList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款通道列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceChannelList",
        }
    },
    {
        path: "/amount/internationalRemittanceCreditedTimesList",
        name: "internationalRemittanceCreditedTimesList",
        exact: true,
        component: InternationalRemittanceCreditedTimesList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款通道时效列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceCreditedTimesList",
        }
    },
    {
        path: "/amount/internationalRemittanceLimitList",
        name: "internationalRemittanceLimitList",
        exact: true,
        component: InternationalRemittanceLimitList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款限额列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceLimitList",
        }
    },
    {
        path: "/amount/internationalRemittanceSlippageList",
        name: "internationalRemittanceSlippageList",
        exact: true,
        component: InternationalRemittanceSlippageList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款滑点列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceSlippageList",
        }
    },
    {
        path: "/amount/internationalRemittanceCurrencyConversionList",
        name: "internationalRemittanceCurrencyConversionList",
        exact: true,
        component: InternationalRemittanceCurrencyConversionList,
        meta: {
            breadcrumb: [
                {
                    name: lang?.name,
                    path: ""
                },
                {
                    name: "国际汇款货币转换列表",
                    path: ""
                }
            ],
            privilegeCode: "internationalRemittanceCurrencyConversionList",
        }
    },
];
